import { z } from 'zod';
import type { SupportedLanguage } from '../../i18n/config';

/**
 * The four self-service preferences. Time zone is modeled as a string where
 * `''` means "use the browser default" (the user has no explicit zone). The
 * submit path diffs against the loaded `MeResponse` and sends only changed
 * fields (partial merge), so an opened-and-saved-unchanged dialog sends nothing.
 */
export interface PreferencesFormValues {
  preferredLanguage: SupportedLanguage;
  preferredTimeZone: string;
  receivesUsageAlerts: boolean;
  receivesBillingReports: boolean;
}

export const preferencesFormSchema = z.object({
  preferredLanguage: z.enum(['en-US', 'es-MX', 'fr-CA']),
  preferredTimeZone: z.string(),
  receivesUsageAlerts: z.boolean(),
  receivesBillingReports: z.boolean(),
});
